// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthenticationRoutes_wrapper__3soXc","logo":"AuthenticationRoutes_logo__OVDsA","content":"AuthenticationRoutes_content__1shXM"};